import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  FiUploadCloud,
  FiX,
  FiGlobe,
  FiMail,
  FiLock,
  FiEye,
  FiEyeOff,
  FiUser,
} from "react-icons/fi";
import { FaLeaf } from "react-icons/fa";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import {
  MdFormatBold,
  MdFormatItalic,
  MdFormatListBulleted,
  MdFormatListNumbered,
  MdLink,
  MdFormatClear,
} from "react-icons/md";
// 1. Image Upload Box (Banner / Logo)
// export const ImageUploadField = ({
//   label,
//   recommended,
//   file,
//   preview,
//   onUpload,
//   onRemove,
//   required,
//   error,
//   name,
// }) => (
//   <div>
//     <label className="form-label">
//       {label} {required && <span className="text-red-500">*</span>}
//     </label>
//     {typeof recommended === "string" ? (
//       <p
//         className="mb-2 text-xs text-gray-400"
//         dangerouslySetInnerHTML={{ __html: recommended }}
//       />
//     ) : (
//       <p className="mb-2 text-xs text-gray-400">{recommended}</p>
//     )}

//     <div className="flex items-center gap-4">
//       {/* Upload Zone */}
//       <label
//         className={`bg-var(--input-bg) flex flex-1 cursor-pointer flex-col items-center justify-center rounded-xl border-2 border-dashed p-4 transition-colors ${
//           error
//             ? "border-red-400 hover:border-red-500"
//             : "border-[var(--input-border-color)]"
//         }`}
//       >
//         <FiUploadCloud className="mb-1 h-6 w-6 text-[var(--color-primary)]" />
//         <span className="text-sm font-medium text-gray-700">
//           Upload {label.split(" ")[0]}
//         </span>
//         <span className="text-xs text-gray-400">
//           Drag & drop or click to browse
//         </span>
//         <input
//           type="file"
//           accept="image/*"
//           onChange={onUpload}
//           name={name || "image"}
//           className="hidden"
//         />
//       </label>

//       {/* Preview Box */}
//       {preview && (
//         <div className="relative flex h-24 w-36 shrink-0 items-center justify-center overflow-hidden rounded-xl border border-gray-200 bg-gray-50">
//           <img
//             src={preview}
//             alt="Preview"
//             className="h-full w-full object-cover"
//           />
//           <button
//             type="button"
//             onClick={onRemove}
//             className="absolute right-1 top-1 rounded-full bg-gray-900/70 p-1 text-white hover:bg-gray-900"
//           >
//             <FiX className="h-3.5 w-3.5" />
//           </button>
//         </div>
//       )}
//     </div>
//     {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
//   </div>
// );
// export const ImageUploadField = ({
//   label,
//   recommended,
//   multiple = false,
//   preview, // Single URL string OR Array of URL strings
//   onUpload,
//   onRemove, // Optional callback: (indexOrItem, name) => void
//   showRemove = true, // Toggle remove button visibility
//   required,
//   error,
//   name,
//   accept = "image/*",
// }) => {
//   // Normalize preview prop into an array for uniform rendering
//   const previews = Array.isArray(preview) ? preview : preview ? [preview] : [];

//   return (
//     <div>
//       <label className="form-label font-medium text-gray-700">
//         {label} {required && <span className="text-red-500">*</span>}
//       </label>

//       {typeof recommended === "string" ? (
//         <p
//           className="mb-2 text-xs text-gray-400"
//           dangerouslySetInnerHTML={{ __html: recommended }}
//         />
//       ) : (
//         <p className="mb-2 text-xs text-gray-400">{recommended}</p>
//       )}

//       <div className="flex flex-col gap-3">
//         {/* Upload Zone */}
//         <label
//           className={`flex cursor-pointer flex-col items-center justify-center rounded-xl border-2 border-dashed p-4 transition-colors ${
//             error
//               ? "border-red-400 "
//               : "border-[var(--color-primary)] "
//           }`}
//         >
//           <FiUploadCloud className="text-[var(--color-primary)] mb-1 h-6 w-6" />
//           <span className="text-[12px] font-medium text-[var(--color-primary)]">
//             Add or Drag and drop your logo image
//           </span>
//           <span className="text-xs text-gray-400">
//             Drag & drop or click to browse{" "}
//             {multiple && "(Multiple files allowed)"}
//           </span>
//           <input
//             type="file"
//             accept={accept}
//             multiple={multiple}
//             onChange={onUpload}
//             name={name || "image"}
//             className="hidden"
//           />
//         </label>

//         {/* Previews Container */}
//         {previews.length > 0 && (
//           <div className="flex flex-wrap items-center gap-3">
//             {previews.map((src, index) => (
//               <div
//                 key={index}
//                 className="relative flex h-24 w-36 shrink-0 items-center justify-center overflow-hidden rounded-xl border border-gray-200 bg-gray-50"
//               >
//                 <img
//                   src={src}
//                   alt={`Preview ${index + 1}`}
//                   className="h-full w-full object-cover"
//                 />

//                 {/* Optional Remove Button */}
//                 {showRemove && onRemove && (
//                   <button
//                     type="button"
//                     onClick={() => onRemove(index, name)}
//                     className="absolute right-1 top-1 rounded-full bg-gray-900/70 p-1 text-white transition-colors hover:bg-gray-900"
//                     title="Remove Image"
//                   >
//                     <FiX className="h-3.5 w-3.5" />
//                   </button>
//                 )}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
//     </div>
//   );
// };


export const ImageUploadField = ({
  label,
  recommended,
  multiple = false,
  preview, // Single URL string OR Array of URL strings
  onUpload,
  onRemove, // Optional callback: (indexOrItem, name) => void
  showRemove = true,
  required,
  error,
  name,
  accept = "image/*",
}) => {
  // Normalize preview prop into an array for uniform check
  const previews = Array.isArray(preview) ? preview : preview ? [preview] : [];
  const singlePreview = previews[0] || null;

  return (
    <div className="w-full">
      {label && (
        <label className="form-label font-medium text-gray-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      {typeof recommended === "string" ? (
        <p
          className="mb-2 text-xs text-gray-400"
          dangerouslySetInnerHTML={{ __html: recommended }}
        />
      ) : (
        <p className="mb-2 text-xs text-gray-400">{recommended}</p>
      )}

      {/* Main Upload Box */}
      <div className="relative w-full">
        <label
          className={`relative flex min-h-[140px] w-full cursor-pointer flex-col items-center justify-center overflow-hidden rounded-xl border-2 border-dashed p-4 transition-colors ${
            error
              ? "border-red-400"
              : "border-[var(--color-primary)]"
          }`}
        >
          <input
            type="file"
            accept={accept}
            multiple={multiple}
            onChange={onUpload}
            name={name || "image"}
            className="hidden"
          />

          {singlePreview ? (
            /* Image Preview inside Upload Box */
            <div className="relative flex h-full min-h-[110px] w-full items-center justify-center p-2">
              <img
                src={singlePreview}
                alt="Uploaded Preview"
                className="max-h-[120px] w-full object-contain"
              />
            </div>
          ) : (
            /* Upload Placeholder State */
            <div className="flex flex-col items-center justify-center py-2">
              <FiUploadCloud className="mb-1 h-7 w-7 text-[var(--color-primary)]" />
              <span className="text-[13px] font-medium text-[var(--color-primary)]">
                Add or Drag and drop your file(s) here
              </span>
              <span className="mt-0.5 text-xs text-gray-400">
                Click anywhere in this box to browse
              </span>
            </div>
          )}
        </label>

        {/* Remove Button Overlay (Top Right) */}
        {singlePreview && showRemove && onRemove && (
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onRemove(0, name);
            }}
            className="absolute right-3 top-3 z-10 rounded-full bg-gray-900/70 p-1.5 text-white transition-colors hover:bg-gray-900"
            title="Remove / Change Image"
          >
            <FiX className="h-4 w-4" />
          </button>
        )}
      </div>

      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
};

export const InputField = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  placeholder,
  icon: Icon,
  required,
  error,
  maxLength,
  disabled = false,
  title = null,
  min, // Added min prop
  max, // Added max prop
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === "password";
  const isNumberOrPhone = type === "phone";

  // Handle number/phone restrictions and maximum character length
  const handleInputChange = (e) => {
    if (isNumberOrPhone) {
      let rawVal = e.target.value;

      // 1. Strip all non-numeric characters (allows digits only)
      let numericOnly = rawVal.replace(/\D/g, "");

      // 2. Restrict to maxLength if specified
      if (maxLength) {
        numericOnly = numericOnly.slice(0, maxLength);
      }

      // 3. Dispatch cleaned numeric string to parent handler
      onChange({
        target: {
          name,
          value: numericOnly,
        },
      });
    } else {
      onChange(e);
    }
  };

  return (
    <div className="w-full">
      {label && (
        <label className="form-label">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative flex items-center">
        {Icon && (
          <div className="pointer-events-none absolute left-3.5 flex items-center justify-center text-gray-400">
            {typeof Icon === "function" ? (
              <Icon className="h-4 w-4 shrink-0" />
            ) : (
              Icon
            )}
          </div>
        )}
        <input
          type={
            isPassword
              ? showPassword
                ? "text"
                : "password"
              : isNumberOrPhone
              ? "text" // Render as "text" to eliminate native browser spin buttons completely
              : type
          }
          inputMode={isNumberOrPhone ? "numeric" : undefined}
          name={name}
          value={value ?? ""}
          onChange={handleInputChange}
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={disabled}
          min={min} // Attached min attribute
          max={max} // Attached max attribute
          style={{
            paddingLeft: Icon ? "2.75rem" : "0.875rem",
            paddingRight: isPassword ? "2.75rem" : "0.875rem",
            borderColor: error ? "#f87171" : "#E2E8F0",
          }}
          className={`input-field ${
            isNumberOrPhone
              ? "[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
              : ""
          }`}
          title={title ? title : ""}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3.5 text-gray-400 hover:text-gray-600 focus:outline-none"
          >
            {showPassword ? (
              <FiEyeOff className="h-4 w-4" />
            ) : (
              <FiEye className="h-4 w-4" />
            )}
          </button>
        )}
      </div>
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
};

// export default InputField;
// export const InputField = ({
//   label,
//   name,
//   type = "text",
//   value,
//   onChange,
//   placeholder,
//   icon: Icon,
//   required,
//   error,
// }) => {
//   const [showPassword, setShowPassword] = useState(false);
//   const isPassword = type === "password";

//   return (
//     <div className="w-full">
//       {label && (
//         <label className="form-label">
//           {label} {required && <span className="text-red-500">*</span>}
//         </label>
//       )}
//       <div className="relative flex items-center">
//         {Icon && (
//           <div className="pointer-events-none absolute left-3.5 flex items-center justify-center text-gray-400">
//             {typeof Icon === "function" ? (
//               <Icon className="h-4 w-4 shrink-0" />
//             ) : (
//               Icon
//             )}
//           </div>
//         )}
//         <input
//           type={isPassword && showPassword ? "text" : type}
//           name={name}
//           value={value}
//           onChange={onChange}
//           placeholder={placeholder}
//           style={{
//             paddingLeft: Icon ? "2.75rem" : "0.875rem",
//             paddingRight: isPassword ? "2.75rem" : "0.875rem",
//             borderColor: error ? "#f87171" : "#E2E8F0",
//           }}
//           className="input-field"
//         />
//         {isPassword && (
//           <button
//             type="button"
//             onClick={() => setShowPassword(!showPassword)}
//             className="absolute right-3.5 text-gray-400 hover:text-gray-600 focus:outline-none"
//           >
//             {showPassword ? (
//               <FiEyeOff className="h-4 w-4" />
//             ) : (
//               <FiEye className="h-4 w-4" />
//             )}
//           </button>
//         )}
//       </div>
//       {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
//     </div>
//   );
// };

// 3. Textarea Field Component
export const TextareaField = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  rows = 3,
  required,
  error,
}) => (
  <div>
    {label && (
      <label className="form-label">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
    )}
    <textarea
      name={name}
      rows={rows}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`bg-var(--input-bg) w-full resize-y rounded-[8px] border p-3 text-sm  text-[var(--input-color)] placeholder-gray-400 transition-colors focus:outline-none ${
        error
          ? "border-red-400 focus:border-red-500"
          : "border-[var(--input-border-color)]"
      }`}
    />
    {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
  </div>
);

// 4. Select Dropdown

// export const SelectField = ({
//   label,
//   name,
//   value,
//   onChange,
//   options = [],
//   placeholder = "Select an option...",
//   isSearchable = false,
//   isDisabled = false,
//   icon: Icon,
//   required = false,
//   error,
// }) => {
//   // Find current selected option object for react-select
//   const selectedOption = options.find((opt) => opt.value === value) || null;

//   // Custom styles for react-select to match your Tailwind UI
//   const customSelectStyles = {
//     control: (provided, state) => ({
//       ...provided,
//       borderRadius: "8px", // rounded-xl
//       borderColor: error ? "#f87171" : "var(--input-border-color)", // red-400 / amber-400 / gray-200
//       paddingLeft: Icon ? "2.25rem" : "0.25rem",
//       paddingTop: "3px",
//       paddingBottom: "3px",
//       backgroundColor: isDisabled ? "#f3f4f6" : "var(--input-bg)",
//       boxShadow: "none",
//       "&:hover": {
//         borderColor: error ? "#ef4444" : "var(--input-border-color)",
//       },
//     }),
//     option: (provided, state) => ({
//       ...provided,
//       backgroundColor: state.isSelected
//         ? "#fef3c7"
//         : state.isFocused
//         ? "#fffbeb"
//         : "#ffffff",
//       color: "#1f2937",
//       cursor: "pointer",
//     }),
//     placeholder: (provided) => ({
//       ...provided,
//       color: "#9ca3af",
//       fontSize: "0.875rem",
//     }),
//     singleValue: (provided) => ({
//       ...provided,
//       color: "#1f2937",
//       fontSize: "0.875rem",
//     }),
//   };

//   return (
//     <div>
//       {label && (
//         <label className="form-label">
//           {label} {required && <span className="text-red-500">*</span>}
//         </label>
//       )}

//       <div className="relative">
//         {/* Render Left Icon if provided */}
//         {Icon && (
//           <div className="pointer-events-none absolute left-3.5 top-1/2 z-10 -translate-y-1/2 text-gray-400">
//             {typeof Icon === "function" ? (
//               <Icon className="h-4 w-4 shrink-0" />
//             ) : (
//               Icon
//             )}
//           </div>
//         )}

//         {isSearchable ? (
//           /* SEARCHABLE SELECT (react-select) */
//           <Select
//             options={options}
//             value={selectedOption}
//             onChange={(opt) =>
//               onChange({
//                 target: { name, value: opt ? opt.value : "" },
//               })
//             }
//             placeholder={placeholder}
//             isDisabled={isDisabled}
//             isSearchable={true}
//             isClearable={!required}
//             styles={customSelectStyles}
//             classNamePrefix="react-select"
//           />
//         ) : (
//           /* DEFAULT HTML SELECT */
//           <div className="relative flex items-center">
//             <select
//               name={name}
//               value={value || ""}
//               onChange={onChange}
//               disabled={isDisabled}
//               style={{
//                 paddingLeft: Icon ? "2.75rem" : "0.875rem",
//               }}
//               className={`w-full appearance-none rounded-xl border bg-white py-2.5 pr-8 text-sm text-gray-800 transition-colors focus:outline-none disabled:cursor-not-allowed disabled:bg-gray-100 ${
//                 error
//                   ? "border-red-400 focus:border-red-500"
//                   : "border-gray-200 "
//               }`}
//             >
//               {placeholder && (
//                 <option value="" disabled hidden>
//                   {placeholder}
//                 </option>
//               )}
//               {options.map((opt, i) => (
//                 <option key={i} value={opt.value}>
//                   {opt.label}
//                 </option>
//               ))}
//             </select>
//             <span className="pointer-events-none absolute right-3.5 text-xs text-gray-400">
//               ▼
//             </span>
//           </div>
//         )}
//       </div>

//       {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
//     </div>
//   );
// };

export const SelectField = ({
  label,
  name,
  value, // Can be string/ID (single) OR array of strings/IDs (multi)
  onChange,
  options = [], // [{ value: "1", label: "Event 1" }]
  placeholder = "Select an option...",
  isSearchable = false,
  isMulti = false,
  isDisabled = false,
  icon: Icon,
  required = false,
  error,
  noOptionsMessage = "No data available",
}) => {
  // Normalize value for react-select
  const getValue = () => {
    if (!options || options.length === 0) return isMulti ? [] : null;

    if (isMulti) {
      const selectedValues = Array.isArray(value) ? value : [];
      return options.filter((opt) => selectedValues.includes(opt.value));
    }

    return options.find((opt) => String(opt.value) === String(value)) || null;
  };

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "38px",
      borderRadius: "8px", // Consistent rounded-xl across all states
      borderColor: error ? "#f87171" : "var(--input-border-color, #E2E8F0)",
      paddingLeft: Icon ? "2.25rem" : "0.25rem",
      backgroundColor: isDisabled ? "#f3f4f6" : "var(--input-bg, #ffffff)",
      boxShadow: "none",
      transition: "all 0.2s ease",
      "&:hover": {
        borderColor: error ? "#ef4444" : "var(--input-border-color, #CBD5E1)",
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow:
        "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
      zIndex: 50,
    }),
    noOptionsMessage: (provided) => ({
      ...provided,
      color: "#9ca3af",
      fontSize: "0.875rem",
      padding: "12px",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "0.875rem",
      backgroundColor: state.isSelected
        ? "#3b82f6"
        : state.isFocused
        ? "#eff6ff"
        : "#ffffff",
      color: state.isSelected ? "#ffffff" : "#1f2937",
      cursor: "pointer",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#e0f2fe",
      borderRadius: "8px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#0369a1",
      fontWeight: "500",
      fontSize: "0.75rem",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#0369a1",
      "&:hover": {
        backgroundColor: "#bae6fd",
        color: "#0c4a6e",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#9ca3af",
      fontSize: "0.875rem",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#1f2937",
      fontSize: "0.875rem",
    }),
  };

  const handleSelectChange = (selected) => {
    let formattedValue;

    if (isMulti) {
      formattedValue = selected ? selected.map((opt) => opt.value) : [];
    } else {
      formattedValue = selected ? selected.value : "";
    }

    onChange({
      target: {
        name,
        value: formattedValue,
      },
    });
  };

  return (
    <div className="w-full">
      {label && (
        <label className="form-label font-medium text-gray-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <div className="relative">
        {Icon && (
          <div className="pointer-events-none absolute left-3.5 top-1/2 z-10 -translate-y-1/2 text-gray-400">
            {typeof Icon === "function" ? (
              <Icon className="h-4 w-4 shrink-0" />
            ) : (
              Icon
            )}
          </div>
        )}

        <Select
          name={name}
          options={options}
          value={getValue()}
          onChange={handleSelectChange}
          placeholder={placeholder}
          isDisabled={isDisabled}
          isSearchable={isSearchable}
          isMulti={isMulti}
          isClearable={!required && !isDisabled}
          noOptionsMessage={() => noOptionsMessage}
          styles={customSelectStyles}
          classNamePrefix="react-select"
        />
      </div>

      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
};

// 5. Phone Input Field with Country Code Picker
export const PhoneNumberField = ({
  label,
  name,
  codeName,
  codeValue,
  phoneValue,
  onChange,
  onCodeChange,
  options = [
    { value: "+40", label: "+40" },
    { value: "+1", label: "+1" },
    { value: "+91", label: "+91" },
  ],
  placeholder = "712 345 678",
  required = false,
  error,
  maxLength,
  disabled = false,
}) => {
  // Custom styles for the embedded prefix react-select
  const prefixSelectStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "auto",
      height: "100%",
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
      padding: 0,
      cursor: "pointer",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 4px 0 12px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#374151",
      fontSize: "0.875rem",
      fontWeight: "500",
      margin: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0 6px 0 0",
      color: "#9ca3af",
      "&:hover": { color: "#4b5563" },
    }),
    indicatorSeparator: () => ({ display: "none" }),
    menu: (provided) => ({
      ...provided,
      width: "120px",
      borderRadius: "8px",
      zIndex: 50,
    }),
  };

  const handlePhoneChange = (e) => {
    let rawVal = e.target.value;
    let numericOnly = rawVal.replace(/\D/g, "");
    if (maxLength) numericOnly = numericOnly.slice(0, maxLength);

    onChange({
      target: {
        name,
        value: numericOnly,
      },
    });
  };

  const selectedCode =
    options.find((opt) => String(opt.value) === String(codeValue)) ||
    options[0];

  return (
    <div className="w-full">
      {label && (
        <label className="form-label font-medium text-gray-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      {/* Unified Input Container */}
      <div
        className={`flex h-[42px] w-full items-center rounded-lg border bg-white transition-colors focus-within:border-[#02a9e0] ${
          error ? "border-red-400" : "border-[#e2e8f0]"
        }`}
      >
        {/* Country Code Picker */}
        <div className="w-[85px] shrink-0">
          <Select
            options={options}
            value={selectedCode}
            onChange={(opt) => {
              const val = opt ? opt.value : "";
              if (onCodeChange) {
                onCodeChange(val);
              } else {
                onChange({ target: { name: codeName, value: val } });
              }
            }}
            isSearchable={true}
            isDisabled={disabled}
            styles={prefixSelectStyles}
            components={{ ClearIndicator: null }}
          />
        </div>

        {/* Vertical Separator Line */}
        <div className="h-5 w-[1px] shrink-0 bg-[#e2e8f0]" />

        {/* Phone Number Input */}
        <input
          type="text"
          inputMode="numeric"
          name={name}
          value={phoneValue ?? ""}
          onChange={handlePhoneChange}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          className="bg-transparent w-full px-3 py-2 text-sm text-gray-800 placeholder-gray-400 focus:outline-none"
        />
      </div>

      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
};

// Your exact ToolbarButton component
function ToolbarButton({ icon, onClick, active }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded-md p-2 text-lg transition ${
        active ? "bg-blue-100 text-blue-600" : "text-gray-600 hover:bg-gray-200"
      }`}
    >
      {icon}
    </button>
  );
}

export const RichTextEditor = ({
  label = "Overview",
  value,
  onChange,
  required = false,
  error,
  readOnly = false,
  maxChars = 500,
}) => {
  // Initialize Tiptap Editor
  const editor = useEditor({
    extensions: [StarterKit, Link.configure({ openOnClick: false })],
    content: value || "",
    editable: !readOnly,
    onUpdate: ({ editor }) => {
      if (onChange) {
        onChange(editor.getHTML());
      }
    },
  });

  useEffect(() => {
    if (editor && value !== undefined) {
      // Only set content if it differs to prevent cursor jumping loops while typing
      const currentHTML = editor.getHTML();
      if (currentHTML !== value) {
        editor.commands.setContent(value || "");
      }
    }
  }, [value, editor]);

  // Calculate character length directly from text content
  const charCount = editor ? editor.getText().length : 0;

  return (
    <div>
      {/* Label */}
      {label && (
        <label className="form-label">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      {/* Toolbar */}
      {!readOnly && (
        <div className="flex gap-1 rounded-t-xl border border-b-0 bg-gray-50 px-2 py-1">
          <select
            className="mr-1 rounded-lg border bg-white px-2 py-1 text-sm focus:outline-none"
            value={
              editor?.isActive("heading", { level: 1 })
                ? "1"
                : editor?.isActive("heading", { level: 2 })
                ? "2"
                : editor?.isActive("heading", { level: 3 })
                ? "3"
                : "p"
            }
            onChange={(e) => {
              const v = e.target.value;
              if (v === "p") {
                editor.chain().focus().setParagraph().run();
              } else {
                editor
                  .chain()
                  .focus()
                  .toggleHeading({ level: Number(v) })
                  .run();
              }
            }}
          >
            <option value="p">Normal</option>
            <option value="1">Heading 1</option>
            <option value="2">Heading 2</option>
            <option value="3">Heading 3</option>
          </select>
          <ToolbarButton
            onClick={() => editor?.chain().focus().toggleBold().run()}
            active={editor?.isActive("bold")}
            icon={<MdFormatBold />}
          />
          <ToolbarButton
            onClick={() => editor?.chain().focus().toggleItalic().run()}
            active={editor?.isActive("italic")}
            icon={<MdFormatItalic />}
          />
          <ToolbarButton
            onClick={() => editor?.chain().focus().toggleBulletList().run()}
            active={editor?.isActive("bulletList")}
            icon={<MdFormatListBulleted />}
          />
          <ToolbarButton
            onClick={() => editor?.chain().focus().toggleOrderedList().run()}
            active={editor?.isActive("orderedList")}
            icon={<MdFormatListNumbered />}
          />
          <ToolbarButton
            onClick={() => {
              const url = prompt("Enter URL");
              if (url) {
                editor?.chain().focus().setLink({ href: url }).run();
              }
            }}
            active={editor?.isActive("link")}
            icon={<MdLink />}
          />
          <ToolbarButton
            onClick={() =>
              editor?.chain().focus().clearNodes().unsetAllMarks().run()
            }
            icon={<MdFormatClear />}
          />
        </div>
      )}

      {/* Editor Content Box */}
      <div
        className={`rounded-xl border transition ${
          error
            ? "border-red-400"
            : "border-gray-300 focus-within:border-blue-400 focus-within:ring-1 focus-within:ring-blue-300"
        } ${!readOnly ? "rounded-t-none" : ""}`}
      >
        <EditorContent
          editor={editor}
          className="overview-editor min-h-[160px] p-4"
        />
      </div>

      {/* Footer */}
      <div className="mt-1 flex items-center justify-between">
        {error ? <p className="text-xs text-red-500">{error}</p> : <span />}
        <p
          className={`text-xs ${
            charCount >= maxChars ? "text-red-500" : "text-gray-500"
          }`}
        >
          {charCount}/{maxChars}
        </p>
      </div>
    </div>
  );
};

// 7. Checkbox Component
export const CheckboxField = ({ label, checked, onChange, error, key }) => (
  <div>
    <label className="inline-flex cursor-pointer select-none items-center gap-2">
      <input
        type="checkbox"
        key={key}
        checked={checked}
        onChange={onChange}
        className={`h-4 w-4 rounded text-amber-500 ${
          error ? "border-red-400" : "border-[var(--input-border-color)]"
        }`}
      />
      <span className="checkbox-label flex items-center gap-1.5">
        {label}
        {/* <FaLeaf className="text-emerald-500 h-3.5 w-3.5" /> */}
      </span>
    </label>
    {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
  </div>
);

export const ColorPickerField = ({
  label,
  name,
  value,
  onChange,
  placeholder = "#000000",
  required = false,
  error,
}) => {
  return (
    <div>
      {/* Standard Label matching other fields */}
      {label && (
        <label className="form-label">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      {/* Input Field Wrapper */}
      <div className="relative flex items-center">
        {/* Color Swatch Trigger */}
        <div className="absolute left-3 z-10 flex items-center">
          <div className="bg-var(--input-bg) relative h-6 w-8 shrink-0 overflow-hidden rounded-md border  border-[var(--input-border-color)] shadow-sm">
            <input
              type="color"
              name={name}
              value={value && value.startsWith("#") ? value : "#000000"}
              onChange={onChange}
              className="bg-transparent absolute -left-2 -top-2 h-10 w-12 cursor-pointer border-0 p-0"
            />
          </div>
        </div>

        {/* Text Input for Hex Code */}
        <input
          type="text"
          name={name}
          value={value || ""}
          onChange={onChange}
          placeholder={placeholder}
          maxLength={7}
          className={`bg-var(--input-bg) w-full rounded-[8px] border p-3 pl-14 font-mono text-sm uppercase text-[var(--input-color)] placeholder-gray-400 transition-colors focus:outline-none ${
            error
              ? "border-red-400 focus:border-red-500"
              : "border-[var(--input-border-color)]"
          }`}
        />
      </div>

      {/* Error Message */}
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
};

export const InputWithButtonField = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  onButtonClick,
  buttonText = "Add",
  placeholder = "Add Highlights",
  required = false,
  error,
  disabled = false,
  buttonDisabled = false,
}) => {
  return (
    <div className="w-full">
      {label && (
        <label className="form-label font-medium text-gray-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      {/* Outer Input Container */}
      <div
        className={`flex h-[42px] w-full items-center justify-between rounded-lg border bg-white p-1 pl-3.5 transition-colors focus-within:border-[#02a9e0] ${
          error ? "border-red-400" : "border-[#e2e8f0]"
        }`}
      >
        <input
          type={type}
          name={name}
          value={value ?? ""}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          className="bg-transparent w-full pr-2 text-sm text-gray-800 placeholder-gray-400 focus:outline-none"
        />

        <button
          type="button"
          onClick={onButtonClick}
          disabled={buttonDisabled}
          className="inside-button"
        >
          {buttonText}
        </button>
      </div>

      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
};
